<template>
  <div>
    <div class="mb-4 flex justify-content-between align-items-center">
      <span v-if="id > 0" class="pr-2 mr-2 font-bold text-2xl"
        >Kontra bon Pelanggan - Edit</span
      >
      <span v-else class="pr-2 mr-2 font-bold text-2xl"
        >Kontra bon Pelanggan - Tambah</span
      >
      <div>
        <i class="pi pi-home mr-2"></i>
        <span v-if="id > 0" class="font-small"
          >/ Penjualan / Kontra bon / Edit</span
        >
        <span v-else class="font-small"
          >/ Penjualan / Kontra bon / Tambah</span
        >
      </div>
    </div>
    <form-kontrabon :id="id" />
  </div>
</template>

<script>
import FormKontrabon from '@/components/penjualan/FormKontrabon'

export default {
  components: {
    FormKontrabon,
  },
  data() {
    return {
      id: parseInt(this.$route.params.id),
    }
  },
}
</script>
